import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "share-error" }
const _hoisted_2 = {
  key: 0,
  class: "error-content"
}
const _hoisted_3 = {
  key: 1,
  class: "error-content"
}
const _hoisted_4 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.code === 403)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " You're trying to access a shared prompt, but access is denied because you and the owner belong to different tenants. "))
      : _createCommentVNode("v-if", true),
    ($props.code === 404)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " You're trying to access a shared prompt but it has already been deleted by the owner. "))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Close ")
        ])),
        _: 1 /* STABLE */
      })
    ])
  ]))
}